import {ImgUrl as ImgUrlModel} from '../../models/editor/imgUrl'
import StyleSheet from '../../utils/helpers/styleSheet'

interface ImgUrlProps {
  img: ImgUrlModel
}

const styles: StyleSheet = {
  img: {
    display: 'block',
  },
}

export default function ImgUrl({img}: ImgUrlProps) {
  return <img src={img.url} alt="" style={styles.img} />
}
